import React from 'react';
import {
  Divider,
  Typography,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Card,
  CardContent,
  CircularProgress,
  Grid
} from '@material-ui/core';
import StorageIcon from '@material-ui/icons/Storage';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

const VirtualStockPanel = ({
  loading,
  total,
  invoices,
  expanded,
  onToggle,
  t,// translation function
  showTitle = true  
}) => {
  const totalQtyStyle = {
    fontWeight: 700,
    color: total > 0 ? '#1976d2' : '#9e9e9e'
  };

  return (
    <>
      <Divider variant="inset" component="li" />
        {showTitle !== false && (
            <Typography>{t('lblVirtualStock')}</Typography>
        )}
      {loading ? (
        <CircularProgress size={18} style={{ marginLeft: '50%', marginTop: 8 }} />
      ) : (
        <>
          {!expanded ? (
            <ListItem button onClick={onToggle}>
              <ListItemText
                primary={
                  <Typography variant="body1">
                    {t('lblTotalAvailableQuantity')}:&nbsp;
                    <span style={totalQtyStyle}>{total}</span>
                  </Typography>
                }
                secondary={
                  <Typography variant="body2" color="textSecondary">
                    {t('lblClickToSeeInvoiceList')}
                  </Typography>
                }
              />
              <ListItemSecondaryAction>
                <StorageIcon style={{ color: '#1976d2' }} />
              </ListItemSecondaryAction>
            </ListItem>
          ) : (
            <Card style={{ marginTop: 8 }}>
              <CardContent style={{ paddingBottom: 8 }}>
                <Grid
                  container
                  alignItems="center"
                  justify="space-between"
                  wrap="nowrap"
                  onClick={onToggle}
                  role="button"
                  tabIndex={0}
                  style={{ cursor: 'pointer' }}
                >
                  <Grid item style={{ minWidth: 0 }}>
                    <Typography
                      variant="body1"
                      noWrap
                      title={`${t('lblTotalAvailableQuantity')}: ${total}`}
                    >
                      {t('lblTotalAvailableQuantity')}:&nbsp;
                      <span style={totalQtyStyle}>{total}</span>
                    </Typography>
                  </Grid>
                  <Grid item onClick={e => e.stopPropagation()}>
                    <ExpandLessIcon fontSize="small" style={{ color: '#9e9e9e' }} />
                  </Grid>
                </Grid>
                <Divider style={{ marginTop: 8, marginBottom: 8 }} />
                {(!invoices || invoices.length === 0) ? (
                  <Typography variant="body2">-</Typography>
                ) : (
                  <>
                    <Grid container style={{ padding: '6px 0' }}>
                      <Grid item xs={7}>
                        <Typography variant="caption" color="textSecondary" style={{ fontWeight: 500 }}>
                          {t('lblInvoiceNumberDate')}
                        </Typography>
                      </Grid>
                      <Grid item xs={5} style={{ textAlign: 'right', paddingRight: 12 }}>
                        <Typography variant="caption" color="textSecondary" style={{ fontWeight: 500 }}>
                          {t('lblAvailableQty')}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Divider style={{ marginBottom: 6 }} />
                    <div style={{ maxHeight: 220, overflowY: 'auto' }}>
                      {invoices.map((inv, idx) => (
                        <React.Fragment key={idx}>
                          <Grid container style={{ padding: '8px 0' }}>
                            <Grid item xs={7}>
                              <Typography variant="body2"><b>{inv.InvoiceNumber}</b></Typography>
                              <Typography variant="caption" color="textSecondary">
                                {inv.InvoiceDate ? inv.InvoiceDate : '-'}
                              </Typography>
                            </Grid>
                            <Grid item xs={5} style={{ textAlign: 'right', paddingRight: 12 }}>
                              <Typography variant="body2"><b>{inv.AvailableQty}</b></Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                        </React.Fragment>
                      ))}
                    </div>
                  </>
                )}
              </CardContent>
            </Card>
          )}
        </>
      )}
    </>
  );
};

export default VirtualStockPanel;